import { Navigate, Route, Routes } from 'react-router-dom';

import { AppLayout } from '@/app/layout';
import { PortalLayout } from '@/app/portal/layout';
import { RequireAuth } from '@/app/RequireAuth';
import { RequirePortalAuth } from '@/app/portal/RequirePortalAuth';
import LoginPage from '@/pages/Login';
import DashboardPage from '@/pages/Dashboard';
import ClientsPage from '@/pages/Clients';
import ClientDetailPage from '@/pages/Clients/ClientDetailPage';
import MerchantsAdminPage from '@/pages/Merchants';
import AdminMerchantDetailPage from '@/pages/Merchants/AdminMerchantDetailPage';
import TransactionsPage from '@/pages/Transactions';
import WebhooksPage from '@/pages/Webhooks';
import LogsPage from '@/pages/Logs';
import AuditPage from '@/pages/Audit';
import ApiKeysPage from '@/pages/ApiKeys';
import UsersPage from '@/pages/Users';
import SettingsPage from '@/pages/Settings';
import ProfilePage from '@/pages/Profile';

import PortalLoginPage from '@/pages/portal/PortalLogin';
import PortalDashboardPage from '@/pages/portal/PortalDashboard';
import PortalMerchantsPage from '@/pages/portal/PortalMerchants';
import PortalMerchantDetailPage from '@/pages/portal/PortalMerchantDetail';
import PortalUsersPage from '@/pages/portal/PortalUsers';
import PortalTransactionsPage from '@/pages/portal/PortalTransactions';
import PortalWebhooksPage from '@/pages/portal/PortalWebhooks';
import PortalProfilePage from '@/pages/portal/PortalProfile';

export default function App() {
  return (
    <Routes>
      {/* ==================== Admin SPA ==================== */}
      <Route path="/login" element={<LoginPage />} />

      {/* Viewer+ */}
      <Route element={<RequireAuth minRole="Viewer" />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/clients/:id" element={<ClientDetailPage />} />
          <Route path="/merchants" element={<MerchantsAdminPage />} />
          <Route path="/merchants/:id" element={<AdminMerchantDetailPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/webhooks" element={<WebhooksPage />} />
          <Route path="/audit" element={<AuditPage />} />
          {/* Self-service profile — any authenticated admin can edit their own row */}
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
      </Route>

      {/* Admin+ */}
      <Route element={<RequireAuth minRole="Admin" />}>
        <Route element={<AppLayout />}>
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/api-keys" element={<ApiKeysPage />} />
          <Route path="/users" element={<UsersPage />} />
        </Route>
      </Route>

      {/* SuperAdmin only */}
      <Route element={<RequireAuth minRole="SuperAdmin" />}>
        <Route element={<AppLayout />}>
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>

      {/* ==================== Client Portal SPA ==================== */}
      <Route path="/portal/login" element={<PortalLoginPage />} />

      <Route element={<RequirePortalAuth minRole="ClientViewer" />}>
        <Route element={<PortalLayout />}>
          <Route path="/portal" element={<PortalDashboardPage />} />
          <Route path="/portal/merchants" element={<PortalMerchantsPage />} />
          <Route path="/portal/merchants/:id" element={<PortalMerchantDetailPage />} />
          <Route path="/portal/transactions" element={<PortalTransactionsPage />} />
          <Route path="/portal/webhooks" element={<PortalWebhooksPage />} />
          {/* Self-service profile — any portal user can edit their own row */}
          <Route path="/portal/profile" element={<PortalProfilePage />} />
        </Route>
      </Route>

      <Route element={<RequirePortalAuth minRole="ClientAdmin" />}>
        <Route element={<PortalLayout />}>
          <Route path="/portal/users" element={<PortalUsersPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
